import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TicketcodeAuthService } from '../_services/_auth/ticketcode-auth.service';
import { customApp } from '../_configuration/configuration';
import { IEventGeneralSettings, ILogin, IRegistration, IRegistrationStandard, RegistrationType } from '@sv/interfaces';

@Injectable()
export class AuthAttendeeGuard implements CanActivate {
  constructor(private ticketcodeAuthService: TicketcodeAuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const isAuth = this.ticketcodeAuthService.getIsAuthenticted();

    // force typecast -> already set in init-app
    customApp.registration = customApp.registration as IRegistration;
    customApp.login = customApp.login as ILogin;
    customApp.generalSettings = customApp.generalSettings as IEventGeneralSettings;
    if (!customApp.login.enabled && !customApp.registration.enabled) {
      return true;
    }
    let enabledEmail = true;
    if (customApp.registration.type === RegistrationType.STANDARD) {
      enabledEmail = (customApp.registration.settings as IRegistrationStandard).enabledEmail;
    }

    if (!isAuth) {
      if (customApp.generalSettings.enableLP) {
        this.router.navigate(['/landingpage']);
      } else if (
        (customApp.login.enabled && customApp.registration.enabled && enabledEmail) ||
        (!customApp.registration.enabled && customApp.login.enabled) ||
        (customApp.login.enabled && customApp.registration.enabled && new Date(customApp.login.enableTime) <= new Date())
      ) {
        this.router.navigate(['/login']);
      } else {
        this.router.navigate(['/register']);
      }
    }

    return isAuth;
  }
}
